import '../../application/core.js';
import './app-megafon-tj.less';

// конфигурация Raven
require('../../application/general/sentry').init('https://2b04a64c42436728288f684c4a7a092d@karaoke.tj/sentry/21', REVISION);
